/**
 * Los filtros del tablero.
 *
 * Fuera del componente porque son los bordes que no se ven mirando la pantalla
 * y que no fallan: muestran una tabla que no dice por qué le falta una fila.
 *
 * La aritmética de paginación vivía acá y se mudó a `lib/paginacion.ts` cuando
 * el segundo listado la necesitó (ADR 0078).
 */

/** Lo que la búsqueda mira de cada OT, y por qué impresora se filtra. */
export interface OrdenFiltrable {
  numero: string;
  cliente: string;
  producto: string;
  estado: string;
  responsable: string | null;
  impresoraId: string | null;
}

/**
 * Si la OT pasa los filtros de la barra.
 *
 * Los filtros se **acumulan**: pasar uno no alcanza. Y el de impresora compara
 * por id y no por nombre — dos equipos pueden llamarse parecido, y el nombre se
 * edita.
 */
export function coincideConFiltros(
  orden: OrdenFiltrable,
  filtros: { texto: string; impresoraId: string },
): boolean {
  if (filtros.impresoraId && orden.impresoraId !== filtros.impresoraId) return false;

  const texto = filtros.texto.trim().toLowerCase();
  if (texto === "") return true;

  return [orden.numero, orden.cliente, orden.producto, orden.estado, orden.responsable ?? ""].some(
    (campo) => campo.toLowerCase().includes(texto),
  );
}
